import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";
import RoutesMap from "../../../../route_control/RouteControl"

export const userDetailsTodo = createAsyncThunk('userDetails', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `user_profile/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const userDetailsSlice = createSlice({
    name: 'userDetails',
    initialState: {
        data: '',
    },
    extraReducers: (builder) => {
        builder.addCase(userDetailsTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = ''
            }

        });
        builder.addCase(userDetailsTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default userDetailsSlice.reducer;

